import React from 'react';
import PropTypes from 'prop-types';

import icons from '../../utils/assets/icons';

import './index.scss';

export default function SearchInput({ onBlur, onChange, onFocus, placeholder, value }) {
  return (
    <div className="SearchInput">
      <img src={icons.search} alt="Search" className="SearchInput__icon" />
      <input
        className="SearchInput__input"
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        type="text"
        value={value}
      />
    </div>
  );
}

SearchInput.propTypes = {
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

SearchInput.defaultProps = {
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  placeholder: '',
  value: '',
};
